import { DOCUMENT } from "@angular/common";
import { Directive, ElementRef, Inject, OnDestroy, OnInit } from "@angular/core";
import { fromEvent, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ChatService } from "../chat.service";

@Directive({
    selector: "[drag]",
})
export class DragDirective implements OnInit, OnDestroy {
    private parent: HTMLElement;
    private element: HTMLElement;

    private subscriptions: Subscription[] = [];

    constructor(
        private elementRef: ElementRef,
        @Inject(DOCUMENT) private document: any,
        @Inject(ChatService) private chatService: ChatService) { }

    ngOnInit(): void {
        this.element = this.elementRef.nativeElement as HTMLElement;
        this.parent = this.element.parentElement;

        // const top = ((window.screen.height - this.parent.clientHeight) / 2)
        // const left = ((window.screen.width - this.parent.clientWidth) /2);
        // this.parent.style.position = "fixed";
        // this.parent.style.top = top + "px";
        // this.parent.style.left = left + "px";

        this.initDrag();
    }

    initDrag(): void {
        const dragStart$ = fromEvent<MouseEvent>(this.element, "mousedown");
        const dragEnd$ = fromEvent<MouseEvent>(this.document, "mouseup");
        const drag$ = fromEvent<MouseEvent>(this.document, "mousemove").pipe(takeUntil(dragEnd$));

        let dragSub: Subscription;

        const dragStartSub = dragStart$.subscribe((event: MouseEvent) => {
            var real = window.getComputedStyle(this.parent),
                winX = parseFloat(real.left),
                winY = parseFloat(real.top);

            var mX = event.clientX,
                mY = event.clientY;

            dragSub = drag$.subscribe((event: MouseEvent) => {
                event.preventDefault();

                this.parent.style.left = winX + event.clientX - mX + 'px';
                this.parent.style.top = winY + event.clientY - mY + 'px';
            });
        });

        const dragEndSub = dragEnd$.subscribe(() => {
            // initialX = currentX;
            // initialY = currentY;

            if (dragSub) {
                dragSub.unsubscribe();
            }
        });

        this.subscriptions.push.apply(this.subscriptions, [dragStartSub, dragSub, dragEndSub,]);
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((s) => s?.unsubscribe());
    }
}